// VueSocialSharing 插件
// 迁移自 main.js 中的社交分享配置

import Vue from 'vue'
import VueSocialSharing from 'vue-social-sharing'

Vue.use(VueSocialSharing, {
  networks: {
    tiktok: 'https://tiktok.com/?url=@url&title=@title',
    instagram: 'https://instagram-stories:/share?url=@url&title=@title',
  }
})
